import { createFileRoute, Outlet } from "@tanstack/react-router"
import ScreenWrapper from "@/components/ScreenWrapper"
import {
  SidebarNavigation,
  SidebarNavigationProps,
} from "@/components/SideBarNavigationItems"
import {
  Button,
  DetailSidebar,
  LayoutWithSidebar,
  ProfileCard,
  Separator,
} from "toptaal-shared"
import {
  EventModalProvider,
  useCurrentStudentSuspenseQuery,
  useEventModalContext,
  useStudentContracts,
  useStudentInvoices,
} from "students-api"
import StudentRegisterModal from "@/components/modals/StudentRegisterModal"
import { QrCodeIcon } from "@heroicons/react/24/outline"

export const Route = createFileRoute("/home")({
  component: HomePageWrapper,
})

function HomePage() {
  const {
    isRegisterModalOpen,
    handleRegisterModalOpen,
    handleRegisterModalClose,
  } = useEventModalContext()
  const { data: currentUser } = useCurrentStudentSuspenseQuery()
  const { unsignedContracts } = useStudentContracts()
  const { unsignedInvoices } = useStudentInvoices()

  const sidebarNavigationItems: SidebarNavigationProps["items"] = [
    {
      label: "Voortgang",
      to: "/home/voortgang",
    },
    {
      label: "Intake",
      to: "/home/intake",
    },
    {
      label: "Contracten",
      to: "/home/contracten",
      badge: unsignedContracts.length,
    },
    {
      label: "Facturen",
      to: "/home/facturen",
      badge: unsignedInvoices.length,
    },
    {
      label: "Rapportages",
      to: "/home/rapportages",
    },
  ]

  const { mustPlanIntake, hasUpcomingIntake } = currentUser

  const registerVariant = hasUpcomingIntake ? "intake" : "lesson"
  const canRegister = hasUpcomingIntake || !mustPlanIntake

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        sidebar={
          <DetailSidebar goBackLabel="Cursist" canGoBack={false}>
            <ProfileCard
              firstName={currentUser.firstName}
              lastName={currentUser.lastName}
              email={currentUser.email}
              phoneNumber={currentUser.phoneNumberCall}
            />

            <Separator className="my-6" />

            {canRegister && (
              <>
                <Button
                  className="w-full bg-white p-4 font-medium text-base"
                  variant="ghost"
                  onClick={handleRegisterModalOpen}
                >
                  <QrCodeIcon className="size-6 mr-2" />
                  Aanmelden bij{" "}
                  {registerVariant === "intake" ? "intake" : "les"}
                </Button>
                <StudentRegisterModal
                  entityType={registerVariant}
                  isRegisterModalOpen={isRegisterModalOpen}
                  setIsRegisterModalOpen={(open: boolean) =>
                    open
                      ? handleRegisterModalOpen()
                      : handleRegisterModalClose()
                  }
                />
              </>
            )}

            <SidebarNavigation items={sidebarNavigationItems} />
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}

function HomePageWrapper() {
  return (
    <EventModalProvider>
      <HomePage />
    </EventModalProvider>
  )
}
